export default {
  en: require('./en.svg'),
  es: require('./es.svg'),
  pl: require('./pl.svg'),
  pt: require('./pt.svg'),
  ru: require('./ru.svg'),
  vi: require('./vi.svg'),
}
